// AuthContextProvider.js
import React, { createContext, useState } from 'react';
import { PropTypes } from 'prop-types';

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };

  const setLoginRole = (user, role) => {
    user.loginRole = role;
    setUser(user);
  };

  const setCaringFor = (user, caringFor) => {
    user.caringFor = caringFor;
    setUser(user);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, setLoginRole, setCaringFor }}>
      {props.children}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContextProvider;
